import { useEffect, useRef } from 'react';
import { useDispatch } from 'react-redux';
import { openDetails } from 'store/actions/uiActions';

/**
 * Dispatches openDetails once per unique entity id.
 * Prevents re-dispatch loops when detail slices re-materialize on render.
 */
export function useHydrateDetailsOnce({ type, data, id, buildPayload }) {
  const dispatch = useDispatch();
  const lastHydratedIdRef = useRef(null);

  useEffect(() => {
    if (id == null || !data) return;
    const nextId = String(id);
    if (lastHydratedIdRef.current === nextId) return;

    lastHydratedIdRef.current = nextId;
    const payload =
      typeof buildPayload === 'function' ? buildPayload({ type, data }) : { type, data };
    dispatch(openDetails(payload));
  }, [dispatch, type, data, id, buildPayload]);
}
